import Swiper from 'swiper';

export default function carouselArticle() {

    $('.swiper-container:not(".gallery-img, .gallery-thumbs, .vehicle-image, .vehicle-thumbs, [data-slider-testimonials], [data-widget-homeslider-slider]")').each(function(index, element) {

        let $this = $(this),
            $carousel = $this.parents('.carousel-wrap').find('.swiper-slide');

        $this.addClass('instance-' + index);
        $this.parents('.carousel-wrap').find('.swiper-next-btn').addClass('swiper-next-btn-' + index);
        $this.parents('.carousel-wrap').find('.swiper-prev-btn').addClass('swiper-prev-btn-' + index);

        if ($(this).hasClass('article-carousel')) {

            let $slides = $('.swiper-slide', $(this));

            if ($slides.length < 2) {
                $(this).toggleClass('_has-single-slide');
            }

            let mySwiper = new Swiper('.instance-' + index, {
                speed: 500,
                navigation: {
                    nextEl: '.swiper-next-btn-' + index,
                    prevEl: '.swiper-prev-btn-' + index
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                breakpoints: {
                    1023: {
                        slidesPerView: 1,
                    }
                }
            });

        }
    });
}